(function () {
    "use strict";

    angular.module("app").directive("habilInstruction", HabilInstructionDirective);

    HabilInstructionDirective.$inject = ["settingsService", "habilBootbox"];
    function HabilInstructionDirective(settingsService, habilBootbox) {
        return {
            restrict: "A",
            scope: {
                instruction: "@habilInstruction"
            },

            link: function (scope, elm) {
                // Do not register handler if no attachment is provided
                if (!scope.instruction)
                    return;

                elm.on("click", showInstructions);

                function showInstructions() {

                    const dialog = {
                        onEscape: false,
                        closeButton: false,
                        size: "large",
                        templateUrl: `${settingsService.GetBaseUrl()}api/Instructions/${scope.instruction}/${settingsService.locale}`,
                    };
                    habilBootbox.alert(dialog).then(angular.noop);
                }
            }
        };
    }
})();